import { useState } from "react";
import React from "react";

const UserCredentialContext = React.createContext<any>({});

export default UserCredentialContext
